import { Suspense } from "react";

// project imports
import Loader from "./Loader";
import LoaderInside from "./LoaderInside";

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component) => (props) => {
	return (
		<Suspense fallback={<LoaderInside />}>
			<Component {...props} />
		</Suspense>
	);
};

export default Loadable;
